import React from 'react';
import { playbookFeatures } from '../data/content';
export function TacticalPlaybookPro() {
  return <section className="w-full bg-[#0a0a0a] px-5 py-16 text-white sm:px-8" data-id="element-251" data-mp="1dr20g7sn7fdl">
      <div className="mx-auto w-full max-w-4xl" data-id="element-252" data-mp="1ir7v7wu7lhzw">
        <h2 className="text-center text-3xl font-extrabold tracking-tight sm:text-4xl" data-id="element-253" data-mp="1ipd9whf0znva">
          Tactical Playbook <span className="text-[#7c3aed]" data-id="element-254" data-mp="1nrce1tilaota">Pro</span>
        </h2>
        <p className="mt-4 text-center text-base text-neutral-400" data-id="element-255" data-mp="1rseeues5n8xd">
          The system that makes every coach look like a professional
        </p>

        <ul className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-256" data-mp="1womo5bjo87wm">
          {playbookFeatures.map(feature => <li key={feature.title} className="flex items-start gap-3 rounded-xl border-l-4 border-[#6d28d9] bg-[#141416] px-5 py-4" data-id="element-257" data-mp="21jsagbgzjol8">
              <span aria-hidden="true" className="text-lg leading-none" data-id="element-258" data-mp="2bhgi21zowqkt">
                ✅
              </span>
              <div data-id="element-259" data-mp="2ff4ghf0ld1hg">
                <p className="text-sm font-extrabold" data-id="element-260" data-mp="dmczngb362tg">{feature.title}</p>
                <p className="mt-1 text-sm text-neutral-400" data-id="element-261" data-mp="dk9yq18eap9y">{feature.description}</p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}